import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'wen-icon-percentage',
  templateUrl: './percentage.component.html',
  styleUrls: ['./percentage.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PercentageIconComponent {}
